import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import memoize from 'memoize-one';

import { indexSyndicatesRequest, deleteSyndicateRequest } from '../../../requests/syndicates';
import { ComponentDataTable, DefaultModal } from '../../../components';

const columns = memoize(() => [
  {
    name: 'CÓDIGO',
    selector: 'code',
    sortable: true,
    grow: '1'
  },
  {
    name: 'NOMBRE',
    selector: 'name',
    sortable: true,
    grow: '1'
  },
  {
    name: 'DIRECCIÓN',
    selector: 'address',
    cell: item => item.full_address,
    sortable: true,
    grow: '1'
  }
]);

class SyndicateDataTable extends Component {
  state = {
    onRequest: true,
    syndicates: [],
    amount: 0,
    moreData: false,
    modalShow: false,
    modalItem: null,
    modalBody: ''
  };

  handleRequest = async params => {
    const { dispatch } = this.props;
    this.setState({
      onRequest: true
    });
    indexSyndicatesRequest({
      dispatch,
      params,
      successCallback: this.handleSuccessIndex
    });
  };

  handleSuccessIndex = response => {
    const syndicates = response.data.data;
    const { amount } = response.data.metadata;
    this.setState({
      syndicates,
      amount,
      onRequest: false
    });
  };

  removeSyndicate = syndicateId => {
    const { dispatch } = this.props;
    deleteSyndicateRequest(syndicateId, {
      dispatch,
      successCallback: this.handleSuccessRemove
    });
  };

  handleButtonClick = (item, action) => {
    const { history } = this.props;
    switch (action) {
      case 'show':
        history.push(`/profile/syndicates/${item.id}`);
        break;
      case 'edit':
        history.push(`/syndicates/${item.id}/edit`);
        break;
      case 'destroy':
        this.setState({
          modalShow: true,
          modalItem: item,
          modalBody: '¿Estás seguro que deseas eliminar este sindicato?'
        });
        break;
      default:
        // eslint-disable-next-line no-console
        console.log('Error: Action not found');
        break;
    }
  };

  handleModalClose = () => {
    this.setState({
      modalShow: false
    });
  };

  handleModalConfirm = () => {
    const { modalItem } = this.state;
    this.removeSyndicate(modalItem.id);
  };

  handleSuccessRemove = () => {
    this.handleModalClose();
    const { moreData } = this.state;
    this.setState({ moreData: !moreData });
  };

  render() {
    const { syndicates, amount, onRequest, moreData, modalShow, modalBody } = this.state;
    return (
      <>
        <ComponentDataTable
          onRequest={onRequest}
          columns={columns()}
          data={syndicates}
          totalRows={amount}
          moreData={moreData}
          resourceRequest={this.handleRequest}
          onRowClicked={item => this.handleButtonClick(item, 'show')}
          pointerOnHover
        />
        <DefaultModal
          title="Eliminar Sindicato"
          body={modalBody}
          show={modalShow}
          handleClose={this.handleModalClose}
          handleConfirm={this.handleModalConfirm}
          titleBtnClose="Cancelar"
          titleBtnSave="Confirmar"
        />
      </>
    );
  }
}

export default withRouter(connect()(SyndicateDataTable));
